import { render, staticRenderFns } from "./edit_and_add_staff_role.vue?vue&type=template&id=763a103e&scoped=true&"
import script from "./edit_and_add_staff_role.vue?vue&type=script&lang=tsx&"
export * from "./edit_and_add_staff_role.vue?vue&type=script&lang=tsx&"
import style0 from "./edit_and_add_staff_role.vue?vue&type=style&index=0&id=763a103e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "763a103e",
  null
  
)

export default component.exports